<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tDoCB4/tc-custom/9780547971155.jpg?1736422860752" alt="This image is the cover for the book Atonement and Other Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Atonement and Other Stories
      </h1>
      <p class="bookDescription body article font2">
        <b>Gaze into the lives of the twentieth century’s wealthy and declining WASP establishment in these twelve stories by the author of <i>The Education of Oscar Fairfax</i>.</b><br/><br/>No one else writes about the moral life of America’s moneyed class with anything approaching Louis Auchincloss’s understanding, sympathy, irony, and humor. In this, his first book of short fiction since the acclaimed <i>Collected Stories</i>, he again brings us news that no other writer can deliver, news about how America’s great families and fortunes are run and the axes and crises on which they turn. Here is how the privileged view their privilege—some with smugness, some with style, some with a crushing sense of civic and personal responsibility. Here is how the rich marry, how they divorce, and, more important, why. Here, definitively and indelibly, is the eastern seaboard’s Wasp establishment—sometimes in its glory, more often in its decline, and always with its values, assumptions, and increasingly fragile sense of self held up for our scrutiny by a master, the most subtle critic of American manners since Edith Wharton.<br/><br/><b>Praise for <i>The Atonement and Other Stories</i></b><br/><br/><b>“The 12 stories collected in “The Atonement” reveal a writer at, or very near, the top of his form.” —<i>Los Angeles Times</i></b><br/><br/><b>“In this PC world, Auchincloss’ crisp, confident tales of the WASP elite almost qualify as guilty pleasures. These 12 stories . . . will satisfy longtime fans and initiates alike with their portraits of investment bankers, lawyers, and socialites testing the limits of silver-plated social niches . . . . As usual, Auchincloss etches out the moral dilemmas of the blue-chip social stratum with reassuring clarity. A” —<i>Entertainment Weekly</i></b><br/><br/><b>“Fragile, often smug, and sometimes silly characters populate this noteworthy collection . . . . these glimpses of the Eastern elite’s manners and moral quandaries will provide an accessible first taste for the Auchincloss novice and an enjoyable read for longtime fans.” —<i>Publishers Weekly</i>, starred review</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Louis Auchincloss
      </h2>
      
      <p class="authorDescription body article">In 2000, Louis Auchincloss was honored&#160;as a &ldquo;Living Landmark&rdquo; by the New York Landmarks Conservancy. During his long career he wrote more than sixty books, including the story collection <I>Manhattan Monologues</I> and the novel <I>The Rector of Justin</I>. The former president of the Academy of Arts and Letters, he resided in New York City until his death in January 2010.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (hmhbooks.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?59019cff